const template = require('./index.html')

module.exports = function createMapButtonComponent() {
	return Ractive.extend({
		template,
		twoway: false,
		data() {
			return {
				street: '',
				city: '',
				state: '',
				zip: '',
				country: '',
				buttonClass: '',
				showButtonText: true,
			}
		},
		computed: {
			mapLink() {
				const address = [
					this.get('street'),
					this.get('city'),
					this.get('state'),
					this.get('zip'),
					this.get('country'),
				]
					.reduce((acc, piece) => {
						if (piece && piece.trim()) {
							return [...acc, piece.trim()]
						} else {
							return acc
						}
					}, [])
					.join(' ')

				return address ? `https://www.google.com/maps/place/${encodeURIComponent(address)}` : false
			},
		},
	})
}
